export default __webpack_public_path__ + "static/media/neg-y.5bdd574a.jpg";